import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { ReactSVG } from 'react-svg';
import { appStore } from '../../state/app';
import CustomBtn from '../../generic/CustomBtn';
import logo from '../../assets/image/logo.svg';
import { checkingLogin } from '../../utils/login';
import ErrorBoundaries from '../../Layouts/ErrorBoundaries';
import storage from '../../utils/storage';

const Login = () => {
  const history = useHistory();
  const { state, update } = useContext(appStore);
  const { wallet, account, app: { errors } } = state;

  const handleSignIn = async () => {
    storage.del('token');
    storage.set('isSignIn', true);
    storage.del('forceWalletReconnect');
    // Always start a fresh wallet auth session on explicit Sign In click.
    const connected = await wallet.signIn({ forceConnect: true, withLoginMessage: true });
    if (!connected) {
      storage.del('isSignIn');
      return;
    }
    const selectedAccount = await wallet.account();
    if (selectedAccount?.accountId) {
      const redirectPath = storage.get('postLoginRedirect');
      if (redirectPath) {
        await checkingLogin(selectedAccount, history, () => {
          storage.del('postLoginRedirect');
          history.push(redirectPath);
        }, true, update);
        if (storage.get('token')) {
          storage.del('postLoginRedirect');
          history.replace(redirectPath);
        }
        return;
      }
      await checkingLogin(selectedAccount, history, () => {}, false, update);
    }
  };

  return (
    <section className="login">
      <ReactSVG src={logo} className="login__logo" />
      <FormattedMessage
        id="login.title"
        values={{
          h2: (...chunks) => <h2 className="login__title">{chunks}</h2>,
          br: <br />,
        }}
      />
      <CustomBtn
        label={(
          <FormattedMessage
            id="login.createAccount"
          />
        )}
        customClass="btn__login-create"
        idLang="login.button"
        handleClick={() => {
          storage.del('token');
          history.push('/welcome');
        }}
      />
      <CustomBtn
        label={(
          <FormattedMessage
            id="login.signIn"
            values={{
              highlight: (...chunks) => <strong className="login__signIn">{chunks}</strong>,
            }}
          />
        )}
        customClass="btn__login-signIn"
        handleClick={handleSignIn}
        idLang="login.button"
      />
      <FormattedMessage
        id="login.agreement"
        values={{
          div: (...chunks) => <div className="login__term-conditions">{chunks}</div>,
          link1: (chunks) => (<Link to="/terms-conditions" target="_blank">{chunks}</Link>),
          link2: (chunks) => (<Link to="/privacy-notice" target="_blank">{chunks}</Link>),
        }}
      />
      {Object.keys(errors).length > 0 && <ErrorBoundaries />}
    </section>
  );
};

export default Login;
